/*
* Copyright (c) 2019 Honeywell International, Inc. All rights reserved.
*
* This file contains trade secrets of Honeywell International, Inc.  No part
*  may be reproduced or transmitted in any form by any means or for any
*  purpose without the express written permission of Honeywell.
*
*/
import { Component, Input, ViewChild } from '@angular/core';
import { Language } from '../../../../context-discovery-services/models/language.model';

@Component({
  selector: 'adminapp-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent {
  readonly SECONDARY_LANGUAGE_CODE_ENGLISH = 'EN';
  @ViewChild('languageSelector') languageSelector;
  @ViewChild('languageSelectorDomRepeat') languageSelectorDomRepeat;
  @ViewChild('secondaryLanguageSelector') secondaryLanguageSelector;

  secondaryLanguage: Language = null;

  @Input()
  public set languages(langs: Array<Language>) {
    if (!this.languageSelectorDomRepeat) {
      return;
    }
    this.languageSelectorDomRepeat.nativeElement.items = langs;
  }

  @Input()
  set selectedLanguageCodes(languageCodes: Array<string>) {
    if (this.languageSelector) {
      this.languageSelector.nativeElement.value = (languageCodes && languageCodes.length > 0) ? languageCodes[0] : null;
    }
    this.computeSecondaryLanguage();

    if (this.secondaryLanguageSelector) {
      this.secondaryLanguageSelector.nativeElement.checked = (this.secondaryLanguage && languageCodes && languageCodes.length > 1
        && languageCodes[1].toUpperCase() === this.SECONDARY_LANGUAGE_CODE_ENGLISH);
    }

  }

  constructor() { }

  onPrimaryLanguageChanged() {
    this.computeSecondaryLanguage();
  }

  computeSecondaryLanguage() {
    if (this.languageSelector && !!this.languageSelector.nativeElement.value
      && this.languageSelector.nativeElement.value.toUpperCase() !== this.SECONDARY_LANGUAGE_CODE_ENGLISH) {
      this.secondaryLanguage = this.languageSelectorDomRepeat.nativeElement.items.find(
        langDetails => langDetails.languageCode.toUpperCase() === this.SECONDARY_LANGUAGE_CODE_ENGLISH);
    } else {
      this.secondaryLanguage = null;
    }
  }

  getSelectedLanguageCodes() {
    let selectedLanguageCodes: Array<string> = null;
    if (this.languageSelector && this.languageSelector.nativeElement.value) {
      selectedLanguageCodes = [this.languageSelector.nativeElement.value];

      if (this.secondaryLanguage && this.secondaryLanguageSelector && this.secondaryLanguageSelector.nativeElement.checked) {
        selectedLanguageCodes.push(this.secondaryLanguage.languageCode);
      }
    }

    return selectedLanguageCodes;
  }
}
